// dialogSlice.js
import { createSlice ,PayloadAction} from '@reduxjs/toolkit';



const initialState={
 isOpen:false,
 isCancelButtonEnabled: true,
 UserName:''
}

const UpdatePassDialogSlice = createSlice({
  name: 'updatepassdialog',
  initialState,
  reducers: {
    reset: () => initialState,
    openDialog: (state) => {
      state.isOpen = true;
    },
    closeDialog: (state) => {
      state.isOpen = false;
    },
    enableCancelButton: (state) => {
      state.isCancelButtonEnabled = true;
    },
    disableCancelButton: (state) => {
      state.isCancelButtonEnabled = false;
    },
    setUserName: (state,action) => {
      state.UserName = action.payload;
    },
  },
});

export const { openDialog, closeDialog,enableCancelButton,disableCancelButton,setUserName } = UpdatePassDialogSlice.actions;
export default UpdatePassDialogSlice.reducer;
